import { Route, Routes } from "react-router-dom";
import "./App.css";
import SignIn from "./Pages/SignIn/SignIn";
import CustomerRoutes from "./Routers/CustomerRoutes";
import Chatbot from "./customer/Components/chatbot/Chatbot";
import MyprofileRouters from "./Routers/DashboardRouter";
import AdminPannel from "./Admin/AdminPannel";
import { GoogleOAuthProvider } from "@react-oauth/google";
import Loginwithgoogle from "./customer/Components/Auth/Loginwithgoogle";
import ProtectedRoute from "./Routers/ProtectedRoute/ProtectedRoute";
import AdminRoute from './Admin/AdminRoute';
// ✅ Import Toastify container
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  const GoogleauthWrapper = () => (
    <GoogleOAuthProvider clientId="66696626054-3lao7kbs78ffgno0gov31kq7v9v25m0d.apps.googleusercontent.com">
      <Loginwithgoogle />
    </GoogleOAuthProvider>
  );

  return (
    <div className="">
      <Routes>
        <Route path="/googlelogin" element={<GoogleauthWrapper />} />
        <Route path="/*" element={<CustomerRoutes />} />
        <Route path="/sign-in" element={<SignIn />} />
        <Route
          path="/admin/*"
          element={
            <AdminRoute>
              <AdminPannel />
            </AdminRoute>
          }
        />
        <Route path="/account/*" element={<MyprofileRouters />} />
      </Routes>

      <Chatbot />

      {/* ✅ Add ToastContainer here (ONCE ONLY) */}
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
}

export default App;
